import { ReactNode } from 'react';

export enum PageType {
  DASHBOARD = 'DASHBOARD',
  LOGIN = 'LOGIN',
  BRANDS = 'BRANDS',
  CATEGORIES = 'CATEGORIES',
  CATALOG = 'CATALOG',
  PRODUCT_FILTERS = 'PRODUCT_FILTERS',
  HIGHLIGHTED_PRODUCTS = 'HIGHLIGHTED_PRODUCTS',
  DAILY_POPULAR_PRODUCTS = 'DAILY_POPULAR_PRODUCTS',
  POPULAR_PRODUCTS = 'POPULAR_PRODUCTS',
  REVIEWS = 'REVIEWS',
  SYNCHRONIZATION_SUMMARY = 'SYNCHRONIZATION_SUMMARY',
  ORDERS = 'ORDERS',
  BOYNER_ORDERS = 'BOYNER_ORDERS',
  TRENDYOL_ORDERS = 'TRENDYOL_ORDERS',
  HEPSIBURADA_ORDERS = 'HEPSIBURADA_ORDERS',
  N11_ORDERS = 'N11_ORDERS',
  PAZARAMA_ORDERS = 'PAZARAMA_ORDERS',
  REFUNDS = 'REFUNDS',
  BASKETS = 'BASKETS',
  COUPONS = 'COUPONS',
  OFFERS = 'OFFERS',
  DISCOUNTS_AT_CHECKOUT = 'DISCOUNTS_AT_CHECKOUT',
  BLOG = 'BLOG',
  PAGES = 'PAGES',
  SLIDERS = 'SLIDERS',
  BANNERS = 'BANNERS',
  SLIDING_BANNERS = 'SLIDING_BANNERS',
  POPUPS = 'POPUPS',
  GALLERIES = 'GALLERIES',
  FRONTEND_SETTINGS = 'FRONTEND_SETTINGS',
  HOMEPAGE_EDITOR = 'HOMEPAGE_EDITOR',
  MENUS = 'MENUS',
  GENERAL_SETTINGS = 'GENERAL_SETTINGS',
  TAXES = 'TAXES',
  TAGS = 'TAGS',
  SHIPPING_PROVIDERS = 'SHIPPING_PROVIDERS',
  USERS = 'USERS',
  COMPANIES = 'COMPANIES',
  AFFILIATE_USERS = 'AFFILIATE_USERS',
  CUSTOMER_ORDERS_REPORT = 'CUSTOMER_ORDERS_REPORT',
  SALES_REPORT = 'SALES_REPORT',
  PRODUCT_SALES_REPORT = 'PRODUCT_SALES_REPORT',
  STOCK_HISTORY_REPORT = 'STOCK_HISTORY_REPORT',
  STOCK_REPORT = 'STOCK_REPORT',
  AI_CHAT = 'AI_CHAT',
}

export interface AdminPage {
  pageType: PageType;
  name: string;
  path: string;
  element: ReactNode;
  disablePadding?: boolean;
}
